import { useSelector } from "react-redux";
import { useCallback, useEffect } from "react";
import TransTable from "../common/TransTable";
import _ from "lodash";
import { Box, IconButton, Switch, Typography } from "@mui/material";
import { PageTitle } from "../common/PageTitle";
import { useDispatch } from "react-redux";
import { getAllUsers } from "../../service";
import { setLoading, setSelectedUser, setUsers } from "../../redux/action";
import { Link, useNavigate } from "react-router-dom";
import Iconify from "../common/Iconify";
import Capsule from "../common/Capsule";
import  Axios  from "axios";
import { local, base_url } from "../backendurl/url";

const getCookieToken = () => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; token=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

let adminUsersFetching = false;


const userTableColumns = (params) => [
  {
    key: "id",
    label: "Admin Id",
    align: "left",
    fontSize : '15px',
    valueRenderer: (data) => {
      return (
        <Link
          component={Typography}
          style={{ color: "black", textDecoration: "none" }}
          to={`/users/view/${data.user_uuid || data.id}`}
        >
          {data["id"]}
        </Link>
      );
    },
  },
  { key: "username", label: "Admin Name", align: "left", fontSize: "15px" },
  { key: "email", label: "Email", align: "left" },
  { key: "mobile_number", label: "Mobile", align: "left", fontSize: "15px" },
 
  {
    key: "is_active",
    label: "Status",
    align: "center",
    fontSize : '14px',
    valueRenderer: (data) => {
      // return <Capsule data={data.user_roles.name} />;
      if(data.is_active == true){
        return <Capsule data='Active' bgColor='#21965333' color='#219653' />;
      }else{
        return <Capsule data='Inactive' bgColor='#87878714' color='#64748B' />;
      }
    },
  },
  {
    key: "action",
    label: "Action",
    align: "center",
    valueRenderer: (data) => {
      return (
        <Box>
          <IconButton onClick={() => params.gotToViewUser(data)}>
            <Iconify icon="eva:eye-outline" size="small" color="primary.main" />
          </IconButton>
        </Box>
      );
    },
  },
];
 



export default function UserList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userList = useSelector((state) => state.users);
  const getUsers = async () => {
    if (adminUsersFetching) return;
    adminUsersFetching = true;
    dispatch(setUsers([]));
    try {
      dispatch(setLoading(true));
      const config = { headers: { Authorization: `Bearer ${getCookieToken()}` } };
      const response = await Axios.get(`${base_url}/api/accounts/user/create?type=admin`, config);
      if (response?.status == 200) {
        dispatch(setUsers(response?.data?.results || response?.data));
      }
    } catch (error) {
      console.error('Failed to fetch admin users:', error);
      if (error?.response?.status !== 401) {
        adminUsersFetching = false;
      }
    } finally {
      dispatch(setLoading(false));
    }
  };

  const gotoAddUser = () => {
    navigate("add");
    dispatch(setSelectedUser({}));
  };

  const gotToEditUser = (data) => {
    dispatch(setSelectedUser(data));
    navigate(`edit/${data.user_uuid || data.id}`);
  };
  const gotToViewUser = (data) => {
    dispatch(setSelectedUser(data));
    navigate(`view/${data.user_uuid || data.id}`);
  };

  const onSearch = () => {};

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <>
      <Box>
        <TransTable
          checkbox={false}
          columns={userTableColumns({ gotToEditUser, gotToViewUser })}
          rows={userList}
          pageTitle="Admin Users"
          addBtnTitle="Add New Admin"
          addBtnAction={gotoAddUser}
        />
      </Box>
    </>
  );
}
